module.exports = __webpack_public_path__ + "img/news-4.6cee78f1.jpg";